import { render, staticRenderFns } from "./CompareSimilarTag.vue?vue&type=template&id=ba41dd2c&scoped=true"
import script from "./CompareSimilarTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareSimilarTag.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba41dd2c",
  null
  
)

export default component.exports